import React, { FC } from 'react';
import { Switch, TouchableOpacity, View } from 'react-native';
import SpotifyPreviewTrack from '../SpotifyPreviewTrack';
import styles from './styles';
import GalanoGrotesqueText from '../GalanoGrotesqueText';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { green, red } from '../../../constants/palette';
import InSessionSwitch from '../InSessionSwitch';

export type SessionCardProps = {
  isDashboard: boolean;
  isActive?: boolean;
  session: any;
  toggleIsActive?: (value: boolean) => void;
  navigation?: any;
};

export const SessionCard: FC<SessionCardProps> = (props) => {
  const { isActive, isDashboard, session, toggleIsActive, navigation } = props;
  const sessionFeedbackCount = session?.allFeedback?.items?.length;
  const sessionLikesArray = session?.allLikes?.items;
  const playCount = session?.playCount || 0;
  let likes = 0;
  let dislikes = 0;
  sessionLikesArray &&
    sessionLikesArray.map((item) => {
      if (item.likeValue < 0) {
        dislikes += 1;
      }
      if (item.likeValue > 0) {
        likes += 1;
      }
    });

  const navigateToResults = () => {
    navigation.navigate('ArtistSessionResults', {
      sessionId: session.id,
    });
  };

  // TODO: FIX THE VIEW, the background color is abstracted and hidden, currently using normal react native view
  return (
    <View style={styles.container}>
      <View style={styles.topRow}>
        <View style={styles.imageContainer}>
          <SpotifyPreviewTrack height="80" id={session.spotifyUri} width="80" />
        </View>
        <View style={styles.trackDetailsContainer}>
          <GalanoGrotesqueText style={styles.artistName}>
            {session.artistName}
          </GalanoGrotesqueText>
          <GalanoGrotesqueText style={styles.trackTitle}>
            {session.trackName}
          </GalanoGrotesqueText>
        </View>
      </View>
      <View style={styles.bottomRow}>
        <View style={styles.likesBox}>
          {/* TODO: Create thumbs box component  */}
          <View style={styles.thumbsBox}>
            <GalanoGrotesqueText style={styles.likesText}>
              Plays: {playCount}
            </GalanoGrotesqueText>
          </View>
          <View style={styles.thumbsBox}>
            <MaterialCommunityIcons
              name="thumb-up-outline"
              size={20}
              color={green}
            />
            <GalanoGrotesqueText style={styles.likesText}>
              {likes}
            </GalanoGrotesqueText>
          </View>
          <View style={styles.thumbsBox}>
            <MaterialCommunityIcons
              name="thumb-down-outline"
              size={20}
              color={red}
            />
            <GalanoGrotesqueText style={styles.likesText}>
              {dislikes}
            </GalanoGrotesqueText>
          </View>
        </View>
        {isDashboard && (
          <>
            {/* TODO: Create Result Box component */}
            <TouchableOpacity
              onPress={navigateToResults}
              style={styles.resultBox}
            >
              <GalanoGrotesqueText>Feedback:</GalanoGrotesqueText>
              <GalanoGrotesqueText>{sessionFeedbackCount}</GalanoGrotesqueText>
            </TouchableOpacity>
            <InSessionSwitch
              isEnabled={!!isActive}
              //@ts-ignore
              toggleSwitch={toggleIsActive}
            />
          </>
        )}
      </View>
    </View>
  );
};

export default SessionCard;
